// extracted by mini-css-extract-plugin
export var actionButton = "_wn-2";
export var card = "_wn-0";
export var disambiguationList = "_wn-3";
export var errorCard = "_wn-4";
export var row = "_wn-1";